module.exports = __webpack_public_path__ + "static/media/byttelyd-Intro.a6d9c9c2.mp3";